<template>
    <div class="container main-content">
        <div class="form-container">
            <img class="ap-logo" src="/logo-ap-fixed.svg"/>
            <h1 class="heading">SAR Tool</h1>
            <h5 class="subheading">Login</h5>
            <form class="form" @submit.prevent>
                <label class="form-label" for="email">Email</label>
                <input
                    id="email"
                    v-model="email"
                    type="text"
                    class="form-input form-control"
                    placeholder="Email"
                    required/>
                <label class="form-label" for="password">Password</label>
                <input
                    id="password"
                    v-model="password"
                    type="password"
                    class="form-input form-control"
                    placeholder="Password"
                    required/>
                <p class="forgot-password">
                    <a
                        href="https://users.advicelinehosting.co.uk/Password/Forgot/"
                        target="_blank">Forgot Password?</a>
                </p>
                <button
                    id="login-button"
                    class="btn btn-block login-button"
                    type="submit"
                    @click="login">
                    Login
                </button>
                <p
                    id="error-message"
                    class="error-message"
                    :style="{
                        visibility: shouldShowError ? 'visible' : 'hidden',
                    }">
                    {{ errorMessage }}
                </p>
            </form>
        </div>
    </div>
</template>

<script>
export default {
    name: 'login',
    data() {
        return {
            email: '',
            password: '',
            errorMessage: '',
        };
    },
    computed: {
        validLogin() {
            return !!this.email && !!this.password;
        },
        shouldShowError() {
            return !!this.errorMessage;
        },
    },
    methods: {
        async login() {
            if (!this.validLogin) {
                return;
            }

            const credentials = {
                email: this.email,
                password: this.password,
            };

            const { data: token, status } = await this.$axios
                .post('/user/v1/authenticate', credentials)
                .catch();

            if (status === 404) {
                return this.couldNotSignIn();
            }
            if (status === 403) {
                return this.userNotAllowed();
            }

            if (status === 200) {
                localStorage.setItem('sartoken', token);
                this.$router.push('/');
            }
        },
        couldNotSignIn() {
            this.errorMessage = `Email or password was incorrect.`;
            this.password = '';
        },
        userNotAllowed() {
            this.errorMessage = `Adviser does not have SAR Tool access.`;
            this.password = '';
        },
    },
};
</script>

<style lang="scss" scoped>
  .main-content {
      height: 100vh;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .form-container {
          width: 60%;
          .heading {
              margin-bottom: 24px;
              color: #676e6e;
              font-weight: bold;
          }
          .heading,
          .subheading {
              text-align: center;
          }
          .ap-logo {
              display: block;
              margin-left: auto;
              margin-right: auto;
              margin-bottom: 12px;
          }
      }
      .form {
          width: 100%;
          input {
              margin-bottom: 12px;
          }
      }
  }
  .forgot-password {
      text-align: right;
      margin-bottom: 12px;
  }
  .error-message {
      text-align: center;
      color: red;
      margin-top: 12px;
  }
  .btn {
      background-color: var(--global-primary-brand);
      color: white;
  }
</style>
